





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import uuid from 'uuid/v4';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { SET_TOOLTIP_ID, TOOLTIP_ID } from '@/types/form.types';

@Component({})
export default class TooltipWidget extends Vue {

  @Prop(String) public tooltipTitle!: string;
  @Prop(String) public tooltipContent!: string;
  @Prop(String) public btnClassProp!: string;
  @Prop(String) public classes!: string;
  @Prop([String, Array]) public placement!: string | string[];
  @Prop([String, Array]) public btnIconProp!: string | string[];
  @Prop(String)
  public staticId!: string;
  @Prop({ type: String, default: 'payrollForm' })
  public formName!: string;

  @Mutation(SET_TOOLTIP_ID, StoreNamespace.FORM) public setTooltipId;

  @Getter(TOOLTIP_ID, StoreNamespace.FORM) public tooltipId!: string;

  public btnClass: string = 'question-mark-icon-img primary-color';
  public btnIcon: string | string[] = ['fal', 'question-circle'];
  public inputId: string | number | boolean = ' ';

  public mounted() {
    this.setTooltipId('');
    this.inputId = this.staticId || 'toolTip' + uuid();
    if (this.formName && !this.staticId) {
      this.inputId = this.formName + '.' + this.inputId;
    }
    if (this.btnIconProp) {
      this.btnIcon = this.btnIconProp;
    }
    if (this.btnClassProp) {
      this.btnClass = this.btnClassProp;
    }
  }

  public onOpen(inputId) {
    this.setTooltipId(inputId);
  }

  public onClose(tooltipIdToClose) {
    if (tooltipIdToClose === this.tooltipId) {
      this.setTooltipId('');
    }
  }

}
